import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseJsonString',
  standalone: true,
})
export class ParseJsonStringPipe implements PipeTransform {
  transform(jsonString: any, path?: string, fallback?: string): any {
    if (!jsonString) return fallback ?? null;

    try {
      const parsed = typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
      if (!path) {
        return parsed;
      }

      const resolved = this.resolvePath(parsed, path);

      // Return the resolved value, fallback if given, or null
      return resolved !== undefined && resolved !== null && resolved !== ''
        ? resolved
        : fallback ?? null;
    } catch {
      return fallback ?? null;
    }
  }

  private resolvePath(obj: any, path: string): any {
    return path
      .split('.')
      .reduce((acc, key) => acc && typeof acc === 'object' && key in acc ? acc[key] : undefined, obj);
  }
}
